import { gql } from '@apollo/client';

export const ACKNOWLEDGE_NOTIFICATIONS = gql`
  mutation AcknowledgeNotifications($input: [NotificationAcknowledgementInput!]!) {
    acknowledgeNotifications(input: $input) {
      notifications {
        id
        events {
          id
        }
      }
      errors {
        message
      }
    }
  }
`;
